import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MATERIAL_IMPORTS } from '../../../material/material-imports';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { LessonService } from '../lesson.service';
import { ActivatedRoute, Params } from '@angular/router';
import { LessonModel } from '@generativ/much-smarter-models';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, ...MATERIAL_IMPORTS, CapitalizePipe, SpinnerComponent],
  selector: 'app-lesson-management',
  templateUrl: './lesson-management.component.html',
  styleUrls: ['./lesson-management.component.scss']
})
export class LessonManagementComponent implements OnInit {

  readonly lesson = signal<LessonModel | null>(null);

  constructor(private lessonService: LessonService,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      const lessonId = +params['lessonId'];
      this.lessonService.getLesson(lessonId).subscribe(
        lessonModel => {
          this.lesson.set(lessonModel);
        }
      );
    });
  }

}
